var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingForecast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 6.25L16 9.75L13.5312 10.2812C13.3437 10.7812 13.0625 11.2187 12.75 11.6562L13.5 14.0312L10.4687 15.7812L8.78125 13.9375C8.53125 13.9687 8.25 14 8 14C7.71875 14 7.46875 13.9687 7.1875 13.9375L5.5 15.7812L2.46875 14.0312L3.25 11.6562C2.90625 11.2187 2.65625 10.7812 2.4375 10.2812L-4.26186e-07 9.75L-2.73196e-07 6.25L2.4375 5.6875C2.625 5.21875 2.90625 4.75 3.21875 4.3125L2.46875 1.9375L5.5 0.1875L7.1875 2.03125C7.4375 2 7.71875 2 8 2C8.25 2 8.53125 2 8.78125 2.03125L10.4687 0.1875L13.5 1.9375L12.75 4.3125C13.0625 4.75 13.3437 5.21875 13.5312 5.6875L16 6.25ZM5.5 8C5.5 9.375 6.59375 10.5 8 10.5C9.375 10.5 10.5 9.375 10.5 8C10.5 6.59375 9.375 5.5 8 5.5C6.59375 5.5 5.5 6.59375 5.5 8Z",
    fill: "#98BCD6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingForecast);
export default __webpack_public_path__ + "static/media/setting_forecast.da22a097061d0281378ad57254eea78e.svg";
export { ForwardRef as ReactComponent };